import { kebabCase } from 'lodash';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { Gender, Language } from '../types/api/graphql';
import { useAvailableHonorificBlockMinuteItems } from './honorific-block-times/use-available-honorific-block-minute-items';

export const useGenderValues = () => {
  const intl = useIntl();

  const data = useMemo(
    () =>
      Object.values(Gender).map(option => ({
        key: option,
        title: intl.formatMessage({
          id: `common.gender.${kebabCase(option)}`,
        }),
      })),
    [intl]
  );

  return {
    data,
    loading: false,
  };
};

export const useLanguageValues = () => {
  const intl = useIntl();

  const data = useMemo(
    () =>
      Object.values(Language).map(option => ({
        key: option,
        title: intl.formatMessage({
          id: `common.language.${kebabCase(option)}`,
        }),
      })),
    [intl]
  );

  return {
    data,
    loading: false,
  };
};

export const useHonorificValues = (
  healthProviderId: string | null | undefined,
  skip?: boolean
) => {
  const intl = useIntl();

  const {
    data: availableHonorificItemsData,
    loading: availableHonorificItemsLoading,
  } = useAvailableHonorificBlockMinuteItems(healthProviderId, skip);

  const data = useMemo(
    () =>
      availableHonorificItemsData.map(option => ({
        key: option.honorific,
        title: intl.formatMessage({
          id: `common.honorific.${kebabCase(option.honorific)}`,
        }),
        blockMinutes: option.blockMinutes,
      })),
    [availableHonorificItemsData, intl]
  );

  return {
    data,
    loading: availableHonorificItemsLoading,
  };
};
